import React from 'react';
import { FiEdit2, FiTrash2, FiFileText } from "react-icons/fi";

const MeetingElement = ({ title, description, date, time, onEdit, onDelete, onReport }) => {
   
  return (
    <tr className="border-b border-slate-100 hover:bg-slate-50/80 transition-all text-center text-sm">
      {/* ساعت */}
    <td className="p-4 text-slate-600 font-bold">{time || "--:--"}</td>      
      {/* تاریخ */}
      <td className="p-4 text-slate-500">{date || "----/--/--"}</td>

      {/* عنوان */}
      <td className="p-4 font-bold text-slate-800 text-right">{title}</td>
      
      {/* توضیحات */}
      <td className="p-4 text-slate-500 text-right truncate max-w-[200px]">{description}</td>

      {/* عملیات */}
      <td className="p-4">
        <div className="flex justify-center items-center gap-2">
          <button onClick={onReport} className="p-2 text-slate-400 hover:text-indigo-600 transition-colors">
            <FiFileText size={16} /> 
          </button>
          
          {onEdit && (
            <button onClick={onEdit} className="p-2 text-slate-400 hover:text-amber-600 transition-colors">
              <FiEdit2 size={16} />
            </button>
          )}
          
          {onDelete && (
            <button onClick={onDelete} className="p-2 text-slate-400 hover:text-rose-600 transition-colors">
              <FiTrash2 size={16} />
            </button>
          )}
        </div>
      </td>
    </tr>
    
  );
};

export default MeetingElement;